import React from 'react';
import { PLAN_HIGHLIGHTS, CIGNA_DIRECTORY_URL } from '../content';
import { LandingButton } from './LandingButton';

const ArrowBullet: React.FC = () => (
  <span
    className="flex items-start justify-center"
    style={{ color: 'var(--color-primary, #143b6b)' }}
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 17 17 7M8 7h9v9" />
    </svg>
  </span>
);

export const PlanHighlights: React.FC = () => {
  return (
    <section className="px-4 md:px-8">
      <div className="mx-auto max-w-[1180px]">
        <div className="grid items-center gap-10 md:grid-cols-2">
          <div
            className="h-[230px] w-full md:h-[300px]"
            style={{
              backgroundColor: 'var(--color-primary, #143b6b)',
              WebkitMaskImage: 'url(/images/landing/map.png)',
              maskImage: 'url(/images/landing/map.png)',
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskSize: 'contain',
              maskSize: 'contain',
              WebkitMaskPosition: 'center',
              maskPosition: 'center',
            }}
          />

          <div>
            <h3 className="font-['Inter'] text-[clamp(1.75rem,2.5vw,33px)] font-semibold leading-[1.08] text-[#23262C]">
              Plan Highlights:
            </h3>
            <ul className="mt-7 space-y-5">
              {PLAN_HIGHLIGHTS.map((item) => (
                <li key={item} className="flex gap-3.5">
                  <ArrowBullet />
                  <span className="font-['Inter'] text-[clamp(1.125rem,1.8vw,21px)] font-normal leading-[1.18] text-[#55585f]">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 flex justify-center">
          <LandingButton
            href={CIGNA_DIRECTORY_URL}
            target="_blank"
            rel="noopener noreferrer"
            arrowClassName="hidden"
            className="normal-case"
          >
            Search Cigna’s provider network
          </LandingButton>
        </div>
      </div>
    </section>
  );
};
